// Section 22 People tab root: reads the store, builds the table view model, renders the table.
import {
  draft,
  game,
  hoverPerson,
  openPersonCard,
  setPeopleGrouping,
  setPeopleSort,
  toggleGroup,
  ui,
} from '../../store';
import { peopleTableVM } from '../../viewModels';
import { PeopleTable } from './people-table';
import './people.css';

export function PeopleTab() {
  const g = game.value;
  if (g === null) return null;
  const u = ui.value;
  const v = u.peopleView;
  return (
    <PeopleTable
      vm={peopleTableVM(g, draft.value, v.sortKey, v.sortDir, v.groupBy, v.expanded)}
      sortKey={v.sortKey}
      sortDir={v.sortDir}
      grouping={v.groupBy}
      hovered={u.hoveredPersonId}
      onSort={setPeopleSort}
      onGrouping={setPeopleGrouping}
      onToggleGroup={toggleGroup}
      onHover={hoverPerson}
      onOpen={openPersonCard}
    />
  );
}
